import React from "react";

export default function FullScreenLoading() {
  return (
    <div className="ds-container">
      <div className="grid _loadingState">
        <p className="bit">Loading</p>
        <div className="animatedDot">
          <span>
          </span>
        </div>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/features/shared/components/misc/FullScreenLoading.js